import {FeatureFlags} from "@bounce/shared/consumer/helpers";
import {CreditReportingType} from "@bounce/shared/consumer/declarations";

enum UserStep {
  ACCOUNTS = "accounts",
  LOGIN = "login",
  ONBOARDING = "onboarding",
  APP = "app",
}

enum PagesURL {
  ACCOUNTS = "accounts",
  ACCOUNT = "account",
  ACCOUNT_DASHBOARD = "account-dashboard",
}

type GeneralEventProps = {
  user_step: string;
  url: string;
  env: string;
  UTM: Record<string, string>;
  event: string;
  error?: string;
  feature_flags?: Record<string, boolean | string | null>;
  batch?: string;
  product?: string;
  partner_code?: string;
  account_public_id?: string;
  primary_account?: boolean;
  credit_reporting_status?: CreditReportingType;
};

type PageClickEventProps = GeneralEventProps & {
  page: string;
  cta: string;
  event_type: string;
  context?: string;
  data?: Record<string, any>;
};

type PageViewEventProps = GeneralEventProps & {
  page: string;
  event_type: string;
  context?: string;
  data?: Record<string, any>;
};

interface IPageEvent {
  page: string;
  data?: Record<string, any>;
}

interface IPageViewEvent extends IPageEvent {
  /**
   * * @deprecated Use user_step only while awaiting asynchronous data from the server.   */
  user_step?: string;
}

interface IPageClickEvent extends IPageEvent {
  cta: string;
}

const extractFeatureFlagValues = (featureFlags: FeatureFlags | undefined): Record<string, boolean | string | null> => {
  if (!featureFlags) return {};
  return Object.fromEntries(Object.entries(featureFlags).map(([key, {value}]) => [key, value]));
};

export {PagesURL, UserStep, extractFeatureFlagValues};
export type {GeneralEventProps, PageClickEventProps, PageViewEventProps, IPageViewEvent, IPageClickEvent};
